const SlidesRiver = [
    {
      image: './Ganga.jpg',
      
      text: 'River name is Ganga.  Length: 2,525 km. Starting Point: Gaumukh, Uttarakhand.Importance: Considered the holiest river by Hindus. Uses: Irrigation, transportation, and drinking water.History: The river has been a cradle of ancient Indian civilizations, cultural and religious significance, and has been worshipped since ancient times.',
    },
    {
      image: './Yamuna.jpg',
      text: 'River name is Yamuna.Length: ~1,376 km.Starting Point: Yamunotri Glacier, Uttarakhand.Importance: Sacred river in Hinduism, associated with many religious sites.Uses: Irrigation, domestic water supply, and industrial use.History: The Yamuna is deeply intertwined with Indian mythology and history, including the story of Lord Krishna.',
    },
    {
      image: './Brahmaputra.jpg',
      text: 'River name is Brahmaputra.Length: ~2,900 km (India: ~916 km).Starting Point: Angsi Glacier, Tibet.Importance: Major river in northeastern India and a crucial lifeline for Assam.Uses: Agriculture, transportation, and hydropower.History: Known for its vastness and cultural significance in Assam; famous for the Brahmaputra floodplains.',
    },
    {
      image: './Godavari.jpg',
      text: 'River name is Godavari.Length: ~1,465 km.Starting Point: Trimbak, Maharashtra.Importance: The second-longest river in India, known as the "Dakshin Ganga" (Ganges of the South).Uses: Irrigation, drinking water, and electricity generation.History: Holds significant historical and cultural importance, flowing through various states and supporting ancient civilizations. ',
    },
    {
        image: './Naramada.jpg',
        text: 'River name is Narmada. Length: ~1,312 km.Starting Point: Amarkantak, Madhya Pradesh.Importance: One of the five holy rivers in India.Uses: Hydropower, irrigation, and drinking water.History: The Narmada River valley is home to diverse wildlife and ancient pilgrimage sites, historically significant to Hindu beliefs.',
      },
  ];
  
  export default SlidesRiver;